// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-delegate-list-item {
  display: flex;
  flex-direction: column;
  padding: 0;
  box-shadow: 0 2px 2px 0 var(--main-gray);
  border-radius: var(--main-border-radius);
  transition: box-shadow 600ms;
  background-color: var(--main-bg-color-lighter);
}
.lsn-delegate-list-item:is([data-status="active"]) {
  border-left: 7px solid color-mix(in srgb, var(--main-eval-requested) 60%, transparent);
}
.lsn-delegate-list-item:is([data-status="active"]):hover {
  border-left-color: var(--main-eval-requested);
  box-shadow: 0 0 10px 0px var(--main-eval-requested);
}
.lsn-delegate-list-item:is([data-status="inactive"]) {
  border-left: 7px solid color-mix(in srgb, var(--main-eval-declined) 60%, transparent);
}
.lsn-delegate-list-item:is([data-status="inactive"]):hover {
  border-left-color: var(--main-eval-declined);
  box-shadow: 0 0 10px 0px var(--main-eval-declined);
}
.lsn-delegate-list-item .delegate-heading {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0.2rem 0.5rem;
}
.lsn-delegate-list-item .delegate-full-name {
  display: flex;
  column-gap: 0.5rem;
  align-items: baseline;
}
.lsn-delegate-list-item .delegate-actions {
  display: flex;
  column-gap: 0.5rem;
}
.lsn-delegate-list-item .delegate-details {
  padding: 0.1rem 0.5rem;
  border-top: var(--main-border-width) solid var(--main-border-color);
}
.lsn-delegate-list-item .delegate-details ul,
.lsn-delegate-list-item .delegate-details li {
  margin: 0;
  padding: 0;
}
.lsn-delegate-list-item .delegate-details .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/pages/manage/delegates/ListDelegates/components/DelegateListItem/DelegateListItem.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,wCAAA;EACA,wCAAA;EACA,4BAAA;EACA,8CAAA;AACF;AAUE;EARE,sFAAA;AACJ;AACI;EACE,6CAAA;EACA,mDAAA;AACN;AAOE;EAZE,qFAAA;AAQJ;AANI;EACE,4CAAA;EACA,kDAAA;AAQN;AAtBA;EA2BI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,sBAAA;AAFJ;AA5BA;EAkCI,aAAA;EACA,kBAAA;EACA,qBAAA;AAHJ;AAjCA;EAwCI,aAAA;EACA,kBAAA;AAJJ;AArCA;EA6CI,sBAAA;EACA,mEAAA;AALJ;AAzCA;;EAkDM,SAAA;EACA,UAAA;AALN;AA9CA;EAuDM,aAAA;EACA,eAAA;EACA,8BAAA;AANN","sourcesContent":[".lsn-delegate-list-item {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  box-shadow: 0 2px 2px 0 var(--main-gray);\n  border-radius: var(--main-border-radius);\n  transition: box-shadow 600ms;\n  background-color: var(--main-bg-color-lighter);\n\n  ._mx_card_status(@status_color) {\n    border-left: 7px solid color-mix(in srgb, @status_color 60%, transparent);\n\n    &:hover {\n      border-left-color: @status_color;\n      box-shadow: 0 0 10px 0px @status_color;\n    }\n  }\n\n  &:is([data-status=\"active\"]) {\n    ._mx_card_status(var(--main-eval-requested));\n  }\n\n  &:is([data-status=\"inactive\"]) {\n    ._mx_card_status(var(--main-eval-declined));\n  }\n\n  .delegate-heading {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding: 0.2rem 0.5rem;\n  }\n\n  .delegate-full-name {\n    display: flex;\n    column-gap: .5rem;\n    align-items: baseline;\n  }\n\n  .delegate-actions {\n    display: flex;\n    column-gap: .5rem;\n  }\n\n  .delegate-details {\n    padding: .1rem .5rem;\n    border-top: var(--main-border-width) solid var(--main-border-color);\n\n    ul,\n    li {\n      margin: 0;\n      padding: 0;\n    }\n\n    .list {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
